import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { ButtonWild } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWild"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import EditorialSelect from "./editorialselect"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

const Wrapper = styled.div`
  margin: 64px auto 0;
  width: 100%;
  max-width: 1170px;
  padding: 0 25px;
  color: ${theme.wild.color.master.base.black};
  @media (min-width: ${theme.mediaqueries.small}) {
    margin: 80px auto 0;
  }
  @media (min-width: ${theme.mediaqueries.medium}) {
    margin: 128px auto 0;
  }
`

const Header = styled.div`
  padding: 0 0 32px;
  margin: auto;
  width: 100%;
  text-align: center;
  @media (min-width: ${theme.mediaqueries.medium}) {
    max-width: 820px;
    padding: 0 0 64px 0;
  }
  h3 {
    padding: 16px 0 0 0;
  }
`

const ContentBox = styled(Box)`
  ${queries.medium`
    min-height: 450px;
  `}
  > .content {
    border-radius: 8px;
    background-color: ${theme.wild.color.master.base.secondary};
    ${queries.medium`
      height: 100%;
    `}
  }
`

const IngrBox = styled(Box)`
  text-align: center;
  margin: 0 0 24px 0;
  width: 100%;
  @media (min-width: ${theme.mediaqueries.small}) {
    margin: 0 0 40px 0;
  }
  @media (min-width: ${theme.mediaqueries.medium}) {
    margin: 0 0 64px 0;
  }
  * {
    margin: 0 auto;
  }
  .text-tablet {
    max-width: 254px;
  }
  .text-desktop {
    max-width: 388px;
  }
`
const BtnBox = styled(Box)`
  margin: auto;
  button {
    span {
      color: #008078;
    }
  }
`

const Editorial = (props) => {
  const {
    data,
    onCtaClick,
    setIngrOption,
    ingrOption,
    title,
    subtitle,
    showInfo,
  } = props
  const { image, imageTablet, imageMobile, button, mobilePadding, slides } =
    data[ingrOption].editorial

  const ImageBox = styled(Box)`
    position: relative;

    ${queries.medium`
      display: flex;
    `}

    button {
      display: block;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    .editorial-image {
      background: transparent center / cover no-repeat url(${imageMobile});
      position: relative;
      height: 0;
      padding-bottom: ${mobilePadding ? mobilePadding : "81.5%"};
      border-radius: 8px;
      ${queries.medium`
        padding-bottom: 0;
        background: transparent center / cover no-repeat url(${imageTablet});
        height: 100%;
        width: 100%;
      `}
      ${queries.large`
        background: transparent center / cover no-repeat url(${image});
      `}
    }
  `

  const handleButtonClick = (button) => {
    segmentEvent("Modal Viewed", {
      name: button.label,
    })

    onCtaClick()
  }

  const renderIngr = slides.map((el, idx) => {
    return (
      <IngrBox key={`i${idx}`}>
        <span className={`show-tablet`}>
          <TextElement
            element="h2"
            text={el.title}
            className={"title--small"}
          />
          <TextElement
            element="p"
            text={el.text}
            className={"body--regular text-tablet"}
          />
        </span>
        <span className={`hide-tablet`}>
          <TextElement
            element="h2"
            text={el.title}
            className={"title--medium"}
          />
          <TextElement
            element="p"
            text={el.text}
            className={"body--xlarge text-desktop"}
          />
        </span>
      </IngrBox>
    )
  })

  return (
    <Wrapper className={`WrapperEditorial`}>
      <Header className={`WrapperEditorialHeader`}>
        <TextElement
          element="h2"
          text={title}
          className="header title--large"
        />
        {subtitle ? (
          <TextElement
            element="h3"
            text={subtitle}
            className="header body--xlarge"
          />
        ) : null}
      </Header>
      <EditorialSelect
        data={data}
        setIngrOption={setIngrOption}
        ingrOption={ingrOption}
        showInfo={showInfo}
      />
      <Flex flexWrap="wrap" mx={[0, 0, -1]}>
        <ImageBox
          className="image-wrap"
          width={[1, null, 1 / 2]}
          mb={[8, 8, 0]}
          px={[0, 0, "4px"]}
        >
          <div className="editorial-image" />
        </ImageBox>
        <ContentBox
          className="content-wrap"
          width={[1, null, 1 / 2]}
          px={[0, 0, "4px"]}
        >
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
            className="content"
            px={[32, 32, 40, 64, 96]}
            py={[32, 32, 64, 96, 96]}
          >
            {renderIngr}
            <BtnBox>
              <ButtonWild
                textLink
                arrowRight
                label={button.label}
                onClick={() => handleButtonClick(button)}
              />
            </BtnBox>
          </Flex>
        </ContentBox>
      </Flex>
    </Wrapper>
  )
}

export default Editorial
